export default "__VITE_ASSET__Uuf_aOSE__"